// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20uWi","col":"styles_col__sC05h","actions":"styles_actions__2vEwz","conflict":"styles_conflict__1h-k0"};